import {CopilotIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'

import styles from './EmptyCliSession.module.css'

export function EmptyCliSession() {
  return (
    <div className={styles.container}>
      <Blankslate narrow>
        <Blankslate.Visual>
          <CopilotIcon size={36} />
        </Blankslate.Visual>
        <Blankslate.Heading>Connection is active and ready to use</Blankslate.Heading>
        <Blankslate.Description>
          Anything you do here will be sent to your connected terminal. This session is private to you.
        </Blankslate.Description>
      </Blankslate>
    </div>
  )
}
